import React, { useState, useEffect } from "react";
import { styled } from "@mui/material/styles";
import Table from "@mui/material/Table";
import TableBody from "@mui/material/TableBody";
import TableCell, { tableCellClasses } from "@mui/material/TableCell";
import TableContainer from "@mui/material/TableContainer";
import TableHead from "@mui/material/TableHead";
import TableRow from "@mui/material/TableRow";
import Paper from "@mui/material/Paper";
import Typography from "@mui/material/Typography";
import Grid from "@mui/material/Grid";
import NoData from "../../assets/noAssets.png";
import Button from "@mui/material/Button";
import DeleteForeverOutlinedIcon from "@mui/icons-material/DeleteForeverOutlined";
import { useTranslation } from "react-i18next";
import { requestUpdatingUserRole } from "../../redux/actions/usersManagementActionCreators";
import { useDispatch } from "react-redux";
import DeleteModal from "./DeleteModal";
import { Avatar } from "@mui/material";
import AccountConfirmed from "../../components/icons/AccountConfirmed";
import ConfirmationPending from "../../components/icons/ConfirmationPending";
import Pagination from "@mui/material/Pagination";
import Stack from "@mui/material/Stack";

const StyledTableCell = styled(TableCell)(({ theme }) => ({
  [`&.${tableCellClasses.head}`]: {
    backgroundColor: "#F3FBF9",
    color: "#B1B4BC",
    height: "50px",
    padding: "0px 16px 0px 16px",
  },
  [`&.${tableCellClasses.body}`]: {
    fontSize: 14,
    borderBottom: "1px solid rgba(0, 0, 0, 0.1)",
  },
}));

const StyledTableRow = styled(TableRow)(({ theme }) => ({
  "&:nth-of-type(odd)": {},
  "&:last-child td, &:last-child th": {
    border: 0,
  },
}));

export default function CustomizedTables({
  rows,
  head,
  handleSelectedUser,
  page,
  handlePage,
  totalPages,
  searchText,
  tabs,
  filter,
}) {
  const { t } = useTranslation();
  const dispatch = useDispatch();

  const storedUser = localStorage.getItem("user");

  const [user, setUser] = useState({});
  const [openDeleteModal, setOpenDeleteModal] = useState(false);

  const handleRole = (value, id) => {
    dispatch(requestUpdatingUserRole(id, value));
  };

  return (
    <div>
      <TableContainer
        component={Paper}
        className="scrollhost"
        sx={{
          width: "100%",
          height: "550px",
          overflowY: "scroll",
          "&.MuiTableContainer-root": {
            borderRadius: "0px",
            boxShadow: "none",
          },
        }}
      >
        <Table
          stickyHeader
          aria-label="customized table"
          sx={{
            "& .MuiTableRow-root:hover": {
              backgroundColor: "#DDF6F0",
              cursor: "pointer",
            },
          }}
        >
          <TableHead>
            <TableRow>
              {head.map((el, i) => (
                <StyledTableCell key={i} align={el.align} width={el.width}>
                  {el.value}
                </StyledTableCell>
              ))}
            </TableRow>
          </TableHead>

          <TableBody>
            {rows?.map((row) => (
              <StyledTableRow
                key={row?.id}
                onClick={() => handleSelectedUser(row)}
              >
                <StyledTableCell
                  align="left"
                  sx={{
                    display: "flex",
                    alignItems: "center",
                    gap: 2,
                  }}
                >
                  <Avatar
                    alt={""}
                    src="https://d34u5ed86vwark.cloudfront.net/MAN1.png"
                  />
                  <Typography variant="title9">
                    {row?.first_name} {row?.last_name}
                  </Typography>
                </StyledTableCell>
                <StyledTableCell align="left">
                  {" "}
                  <Typography variant="title9">{row?.email}</Typography>
                </StyledTableCell>
                <StyledTableCell align="left">
                  {" "}
                  <Typography variant="title9">{t(row?.role)}</Typography>
                </StyledTableCell>
                <StyledTableCell align="left">
                  {row?.id !== JSON.parse(storedUser).public_id && (
                    <div
                      style={{
                        display: "flex",
                        gap: 9,
                        alignItems: "center",
                      }}
                    >
                      {row?.status ? (
                        <AccountConfirmed />
                      ) : (
                        <ConfirmationPending />
                      )}
                      <Typography
                        variant="title9"
                        sx={{
                          color: row?.status ? "#1DB954" : "#D9822F",
                        }}
                      >
                        {row?.status ? t("user_confirmed") : t("user_pending")}
                      </Typography>
                    </div>
                  )}
                </StyledTableCell>
                <StyledTableCell align="center">
                  {JSON.parse(storedUser).role === "cytailor_admin" &&
                  row?.id !== JSON.parse(storedUser).public_id ? (
                    ((row?.role === "cytailor_admin" &&
                      JSON.parse(storedUser).super_admin) ||
                      row?.role !== "cytailor_admin") && (
                      <Button
                        variant="contained"
                        color="disabled"
                        size="small"
                        sx={{ height: "40px", width: "40%" }}
                        onClick={(e) => {
                          e.stopPropagation();
                          setOpenDeleteModal(true);
                          setUser(row);
                        }}
                      >
                        <DeleteForeverOutlinedIcon />
                      </Button>
                    )
                  ) : row?.id !== JSON.parse(storedUser).public_id ? (
                    <Button
                      variant="contained"
                      color="disabled"
                      size="small"
                      sx={{ height: "40px", width: "40%" }}
                      onClick={(e) => {
                        e.stopPropagation();
                        setOpenDeleteModal(true);
                        setUser(row);
                      }}
                    >
                      <DeleteForeverOutlinedIcon />
                    </Button>
                  ) : null}

                  {/* 
                  
                  {row?.id !== JSON.parse(storedUser).public_id && row?.role === "cytailor_admin" && JSON.parse(storedUser).super_admin &&(
                    <Button
                      variant="contained"
                      color="disabled"
                      size="small"
                      sx={{ height: "40px", width: "40%" }}
                      onClick={(e) => {
                        e.stopPropagation();
                        setOpenDeleteModal(true);
                        setUser(row);
                      }}
                    >
                      <DeleteForeverOutlinedIcon />
                    </Button>
                  )} */}
                </StyledTableCell>
              </StyledTableRow>
            ))}
          </TableBody>
        </Table>
        {rows.length === 0 && (
          <Grid container sx={{ textAlign: "center", mt: "100px" }}>
            <Grid item xs={12}>
              <Typography variant="title">No Data Found</Typography>
            </Grid>
            <Grid item xs={12}>
              <img src={NoData} alt="No Data" />
            </Grid>
          </Grid>
        )}
        <DeleteModal
          open={openDeleteModal}
          handleClose={() => setOpenDeleteModal(false)}
          user={user}
          buttonLabel={t("confirm")}
          page={page}
          searchText={searchText}
          tabs={tabs}
          filter={filter?.orga_id}
        />
      </TableContainer>
      <Stack spacing={2} justifyContent="right" direction="row">
        <Pagination
          count={totalPages}
          page={page}
          onChange={(e, p) => handlePage(p)}
          variant="outlined"
          shape="rounded"
          color="secondary"
        />
      </Stack>
    </div>
  );
}
